import { UserCard } from "@/components/cards";
import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { createdAtFormatter } from "@msuite/utils/date";
import type { Tables } from "@msuite/utils/types";
import { getFullName } from "@msuite/utils/users";

const columnHelper = createColumnHelper<Tables<"protocolCallRequestEvents">>();

export const columns = [
	columnHelper.accessor(createdAtFormatter, {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.display({
		id: "createdBy",
		header: localized("users.user"),
		cell: (cell) => (
			<UserCard
				userId={cell.row.original.createdBy}
				render={(user) => getFullName(user)}
			/>
		),
	}),
	columnHelper.accessor("type", {
		id: "type",
		header: localized("general.type"),
		cell: (cell) =>
			cell.getValue() === "resolved"
				? localized("protocols.callback_resolved")
				: localized("protocols.callback_attempt"),
	}),
	columnHelper.accessor("note", {
		id: "note",
		header: localized("notes.note"),
	}),
];
